import { Component } from "react";
import type { ReactNode, ErrorInfo } from "react";
import { logError } from "../lib/logger.js";

interface Props { children: ReactNode; }
interface State { hasError: boolean; message: string; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: "" };

  static getDerivedStateFromError(err: Error): State {
    return { hasError: true, message: err.message };
  }

  componentDidCatch(err: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary]", err, info.componentStack);
    logError("ErrorBoundary.componentDidCatch", err, {
      componentStack: info.componentStack ?? undefined,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          height: "100vh", gap: 12, padding: 32,
        }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "var(--color-error)", margin: 0 }}>Something went wrong</h2>
          <p style={{ fontSize: 14, color: "var(--color-text-secondary)", margin: 0, maxWidth: 480, textAlign: "center" }}>
            {this.state.message || "An unexpected error occurred. Refresh the page or contact support."}
          </p>
          <button
            onClick={() => this.setState({ hasError: false, message: "" })}
            style={{
              padding: "8px 20px", background: "var(--color-brand-600)", color: "#fff",
              border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600, fontSize: 14,
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
